import React, { useState } from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import Botao from 'Component/Botao';
import Icone from 'Component/Icone';
import Imagem from 'Component/Imagem';
import Modal from 'Component/Modal';
import Matricula from 'Interface/Matriculas';

import Avaliacoes from './Avaliacoes';

interface Props {
  dados: Matricula;
}

const Lista = ({ dados }: Props): React.ReactElement => {
  const [modal, setModal] = useState<boolean>(false);

  return (
    <div className="d-flex border-bottom align-items-center py-2 px-3 justify-content-between">
      <div className="d-flex align-items-center w-100 position-relative">
        <Link to={`/admin/cursos/editar/${dados.curso?.id}`} className="me-3">
          <Imagem
            src={dados.curso?.imagem}
            alt={dados.curso?.nome}
            className={['rounded-circle', 'object-fit-cover'].class()}
            width="80"
            height="80"
          />
        </Link>
        <div className="ms-2 fs-4 text-truncate">
          <Link
            to={`/admin/cursos/editar/${dados.curso?.id}`}
            className="text-decoration-none"
          >
            {dados.curso?.nome}
          </Link>
          <small className="d-block fs-6 text-muted">
            {dados.curso?.categoria?.nome}
          </small>
        </div>
      </div>
      <BrowserView className="d-flex align-items-center">
        <div className="text-end fs-4">
          {dados.concluido ? (
            <Icone nome="check2-circle" className="text-success" />
          ) : (
            <Icone nome="x-circle" className="text-danger" />
          )}
        </div>
        <div className="ms-5 fs-5 text-end text-nowrap">
          {dados.criado.data().toLocaleString()}
          <small className="d-flex fs-6 text-muted justify-content-end">
            <Icone nome="calendar" className="me-2" />
            Matriculado em
          </small>
        </div>
        <div className="ms-5 text-end">
          <Botao
            tema="secondary"
            onClick={() => setModal(true)}
            icone="file-earmark-richtext"
          />
        </div>
      </BrowserView>
      <Modal
        lg
        exibir={modal}
        aoFechar={setModal}
        titulo="Avaliações realizadas pelo aluno"
      >
        <Avaliacoes usuarioId={dados.usuario_id} cursoId={dados.curso_id} />
        <div className="mt-3 d-flex justify-content-end">
          <Botao tema="light" onClick={() => setModal(false)}>
            Fechar
          </Botao>
        </div>
      </Modal>
    </div>
  );
};

export default Lista;
